import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, OnDestroy, Output, Directive, Optional } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare interface ColorsObject {
  primary: string;
  secondary: string;
  material: string;
  text: string;
}

@Directive()
@Injectable()
export class ColorsService implements OnDestroy {
  @Output() onLogoChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() onColorChange: EventEmitter<ColorsObject> = new EventEmitter<ColorsObject>();

  private colors: ColorsObject = {
    primary: null,
    secondary: null,
    material: 'primary',
    text: null
  };
  private _logo: string = null;
  get logo(): string {
    return this._logo;
  }
  set logo(url: string) {
    this.onLogoChange.emit(url);
    this._logo = url;
  }

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    @Optional()
    private http: HttpClient
  ) { }


  ngOnDestroy() {
    this.destroy$.unsubscribe();
  }

  public setColors(primary: string, secondary: string = null, rgb: boolean = true): void {
    if (rgb) {
      this.colors.primary = primary;
      this.colors.secondary = secondary;
      this.colors.text = this.getTextColor(primary);
    } else {
      this.colors.primary = this.hexToRgb(primary);
      this.colors.secondary = this.hexToRgb(secondary);
      this.colors.text = primary ? this.getTextColor(this.hexToRgb(primary)) : null;
    }

    if (primary) {
      this.http.get('/assets/css/custom.css', { responseType: 'text' }).pipe(takeUntil(this.destroy$)).subscribe(
        (response: string) => {
          const style = document.createElement('style');
          style.id = 'custom-styles';
          if (primary === '#0f3e4d') {
            style.innerHTML = response.split('newColor').join(primary).split('newTextColor').join(this.colors.text).split('signaturit').join('#8fce3d');
          } else {
            style.innerHTML = response.split('newColor').join(primary).split('newTextColor').join(this.colors.text).split('signaturit').join(primary);
          }
          document.body.appendChild(style);
        }, (error: any) => {
        }
      );

      document.body.classList.add('custom-theme');
      document.cookie = 'color=' + primary + ';path=/;';
      this.onColorChange.emit(this.colors);
    } else {
      if (document.getElementById('custom-styles')) {
        document.getElementById('custom-styles').remove();
      }
      if (document.cookie) {
        document.cookie = 'color=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      }
    }
    this.colors.material = primary ? null : 'primary';
  }

  public deleteColors() {
    this.colors.primary = null;
    this.colors.secondary = null;
    this.colors.material = 'primary';
    this.colors.text = null;
    document.body.classList.remove('custom-theme');
    if (document.cookie) {
      document.cookie = 'color=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    }
  }

  private getTextColor(color: string): string {
    if (!color) {
      return null;
    }
    const c: any = color.substring(color.indexOf('(') + 1, color.indexOf(')')).split(',');

    return (c[0] * 0.299 + c[1] * 0.587 + c[2] * 0.114) > 186 ? '#000000' : '#FFFFFF';
  }

  private hexToRgb(hex): string {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result ? 'rgb(' + parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16) + ')' : null;
  }

  public getColor(type: string) {
    return this.colors[type];
  }

}
